import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Remove markdown code blocks from text while preserving other content.
 * Matches triple-backtick fenced code blocks with optional language specifiers.
 *
 * @param text - Text potentially containing ```code blocks```
 * @param placeholder - Optional text to replace code blocks (default: empty string)
 * @returns Text with code blocks removed/replaced
 *
 * @example
 * removeCodeBlocks("Hello\n```tsx\ncode\n```\nWorld")
 * // Returns: "Hello\n\nWorld"
 */
export function removeCodeBlocks(text: string, placeholder?: string): string {
  const replacement = placeholder || '';
  // Match: ``` + optional language + any content + closing ```
  // Non-greedy [\s\S]*? prevents matching across multiple blocks
  return text.replace(/```[\s\S]*?```/g, replacement);
}
